import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "timeline" }
const _hoisted_2 = { class: "timeline-skeleton-item__icon" }
const _hoisted_3 = { class: "timeline-skeleton-item__content" }

interface Props {
    nbItems: number,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TimelineLoader',
  props: {
    nbItems: { default: 5 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_CompassSkeleton = _resolveComponent("CompassSkeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.nbItems, (index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "timeline-skeleton-item"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_CompassSkeleton, {
            variant: _ctx.CompassEnums.SkeletonVariantType.SQUARE,
            size: _ctx.CompassEnums.SkeletonSize.MEDIUM
          }, null, 8 /* PROPS */, ["variant", "size"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_CompassSkeleton, {
            variant: _ctx.CompassEnums.SkeletonVariantType.LINE,
            size: _ctx.CompassEnums.SkeletonSize.MEDIUM,
            class: "timeline-skeleton-item__title"
          }, null, 8 /* PROPS */, ["variant", "size"]),
          _createVNode(_component_CompassSkeleton, {
            variant: _ctx.CompassEnums.SkeletonVariantType.LINE,
            size: _ctx.CompassEnums.SkeletonSize.MEDIUM,
            class: "timeline-skeleton-item__description"
          }, null, 8 /* PROPS */, ["variant", "size"])
        ])
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})